import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { DatePickerFigo } from '../../../common';

import './DateInput.css';

const DateInput = ({
  useMarginLeft = true,
  maxDate = '',
  minDate = '',
  onSelectedValidDate = () => { },
  selectedDate = '',
  title = '',
}) => {
  const { t } = useTranslation('fileClaimbot');

  // just for comparing dates, not for displaying
  const formatDate = (date) => moment(date).format('YYYY-MM-DD');

  const onDatePickerChange = useCallback((date) => {
    const dateFormatted = formatDate(date);
    const minDateFormatted = formatDate(minDate);
    const maxDateFormatted = formatDate(maxDate);

    const inRange = date && dateFormatted >= minDateFormatted
      && dateFormatted <= maxDateFormatted;
    onSelectedValidDate({ date, inRange });
  }, [maxDate, minDate]);

  return (
    <div
      className="File-claim-date-input-container"
      data-margin-left={useMarginLeft}
    >
      <span>{title || t('dateOfClaim')}</span>

      <DatePickerFigo
        maxDate={maxDate}
        minDate={minDate}
        name="claim-date"
        onDateChange={onDatePickerChange}
        selectedDate={selectedDate}
      />
    </div>
  );
};

export { DateInput };
